"use client";

import { Button } from "@/components/ui/button";
import { Typography } from "@/components/ui/typography";
import Image from "next/image";
import Link from "next/link";
import { ROUTES } from "@/constants";

type ContentfulImage = {
  fields: {
    file: {
      url: string;
      details?: {
        image: {
          width: number;
          height: number;
        };
      };
    };
  };
};

type LanguageHeroProps = {
  content: {
    name: string;
    heroDescription: string;
    slug: string;
    heroImage?: ContentfulImage;
    imageWidth?: number;
  };
};

export default function HeroLanguage({ content }: LanguageHeroProps) {
  const { name, heroDescription, heroImage, imageWidth = 602 } = content;

  const imageUrl = heroImage?.fields?.file?.url
    ? `https:${heroImage.fields.file.url}`
    : null;

  const imageDimensions = heroImage?.fields?.file?.details?.image;
  return (
    <section className="overflow-hidden section pt-[var(--main-header-height,56px)] lg:pt-[var(--main-header-height,54px)] bg-background-hero">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 pt-6 gap-8 md:pt-30 lg:text-start lg:grid-cols-[9fr_11fr] lg:gap-[22px] lg:py-20">
          <div className="flex flex-col justify-center gap-8 lg:max-w-[496px]">
            <div className="grid grid-cols-1 gap-4 md:gap-8">
              <Typography variant="headingMain" className="w-full">
                <h1>{name}</h1>
              </Typography>
              <Typography variant="bodyLg" asChild>
                <p>{heroDescription}</p>
              </Typography>
            </div>
            <div className="grid grid-cols-1 gap-4 sm:flex flex-wrap lg:gap-2.5">
              <Button
                asChild
                variant="primary"
                className="sm:w-[247px] h-[48px]"
              >
                <Link href={ROUTES.startOrder} className="!text-base w-full">
                  Start order
                </Link>
              </Button>
            </div>
          </div>
          {imageUrl && (
            <div className="flex">
              <Image
                alt="Languex Illustration"
                src={imageUrl}
                width={imageDimensions?.width || 602}
                height={imageDimensions?.height || 516}
                className="w-full h-full"
                quality={100}
              />
            </div>
          )}
        </div>
      </div>
    </section>
    //     <div className="container mx-auto">
    //       <div className="grid grid-cols-1 md:grid-cols-2 pt-30 pb-10 ">
    //         <div className="flex flex-col gap-8 max-w-[509px]">
    //           <h1 className="text-[54px]/18 font-medium">{name}</h1>
    //           <p className="text-[20px] w-[90%]">{heroDescription}</p>
    //           <div className="flex gap-4">
    //             <Button
    //               asChild
    //               className="rounded-3xl bg-[#4381E5] hover:bg-transparent
    //               hover:text-[#4381E5] hover:border-[#4381E5] border font-semibold text-[14px] w-[247px] h-[48px]"
    //             >
    //               <Link href="#">Start order</Link>
    //             </Button>
    //           </div>
    //         </div>

    //         {imageUrl && (
    //   <div
    //     className="flex justify-end -ml-9 text-[#1B1F3B] relative h-[516px]"
    //     style={{ width: imageWidth }}
    //   >
    //     <div className="absolute top-[-10%] left-[0%]">
    //       <Image
    //         alt="hero image"
    //         src={imageUrl}
    //         width={imageDimensions?.width || 602}
    //         height={imageDimensions?.height || 516}
    //         className="w-full h-full"
    //         quality={100}
    //         priority
    //       />
    //     </div>
    //   </div>
    // )}
    //       </div>
    //     </div>
  );
}
